import * as components from "../components/custom-components.js";
export function getComponents(customComponents) {
    return {
        ...components,
        ...customComponents
    };
}
//# sourceMappingURL=getComponents.js.map